import { createImmerReducer } from "common/reducerBase";
import UnsplashRecord, { getNewList, initialFilters } from "../data/UnsplashRecord";
import { types } from "../actions";
import { EDITORIAL_SLUG } from "../data/consts";

export default {
	unsplash: createImmerReducer(UnsplashRecord(), {
		[types.SIGN_IN]: (draft: UnsplashRecord) => {
			draft.isSignedIn = true;
			draft.isFiltersPanelOpen = false;
			draft.areFiltersSet = false;
			draft.filters = initialFilters();
			draft.slug = undefined;
		},
		[types.SIGN_OUT]: (draft: UnsplashRecord) => {
			draft.isSignedIn = false;
			draft.isFiltersPanelOpen = false;
			draft.areFiltersSet = false;
			draft.filters = initialFilters();
			draft.slug = undefined;
			draft.list = {
				...getNewList()
			};
		},
		[types.SET_RESULTS_RETRIEVE_START]: (draft: UnsplashRecord, { payload } ) => {
			draft.list.assetsInProgress = true;
		},
		[types.SET_RESULTS_RETRIEVE_END]: (draft: UnsplashRecord, { payload } ) => {
			draft.list.assetsInProgress = false;
		},
		[types.SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS]: (draft: UnsplashRecord, { payload }) => {
			draft.homePageItems = payload.items;
		},
		[types.SELECT_ASSETS]: (draft: UnsplashRecord, { payload }) => {
			draft.list.selected = draft.list.selected === payload.items ? undefined : payload.items;
			draft.selectedFormat = undefined;
		},
		[types.SET_RESULTS_RETRIEVE_SUCCESS]: (draft: UnsplashRecord, { payload }) => {
			draft.list.items.push(...payload.items);
			draft.list.page = payload.page;
			draft.list.hasMoreAssets = payload.hasMoreAssets;
		},
		[types.CLEAR_RESULTS]: (draft: UnsplashRecord, { payload }: SearchParams) => {
			draft.list = {
				...getNewList(),
				assetsInProgress: draft.list.assetsInProgress
			};
		},
		[types.SET_SEARCH_PARAMS]: (draft: UnsplashRecord, { payload }) => {
			draft.searchPhrase = payload.searchPhrase || "";
			draft.slug = payload.slug;
			if (payload.filters) {
				draft.filters = payload.filters;
			}
			if (payload?.orderBy) {
				draft.orderBy = payload.orderBy;
			}
			draft.areFiltersSet = Boolean(
				draft.filters?.color || draft.filters?.orientation || draft.filters?.colorType || (draft.slug && payload.slug !== EDITORIAL_SLUG)
			);
		},
		[types.CLEAR_SEARCH_PHRASE]: (draft: UnsplashRecord, { payload }) => {
			draft.searchPhrase = "";
			draft.list = {
				...getNewList()
			};
		},
		[types.CLEAR_FILTERS]: (draft: UnsplashRecord) => {
			draft.areFiltersSet = false;
			draft.filters = initialFilters();
			draft.slug = draft.searchPhrase ? "" : EDITORIAL_SLUG;
		},
		[types.TOGGLE_FILTERS_PANEL]: (draft: UnsplashRecord) => {
			draft.isFiltersPanelOpen = !draft.isFiltersPanelOpen;
		},
		[types.SELECT_ASSETS_FORMAT]: (draft: UnsplashRecord, { payload }) => {
			draft.selectedFormat = payload;
		},
		[types.RETRIEVE_ASSET_DETAILS_SUCCESS]: (draft: UnsplashRecord, { payload }) => {

			const itemsIndex = draft.list.items.findIndex((item) => item.id === payload.id);
			const homeItemsIndex = draft.homePageItems.findIndex((item) => item.id === payload.id);

			if (itemsIndex > -1) {
				draft.list.items[itemsIndex] = { ...draft.list.items[itemsIndex], ...payload };
			}
			if (homeItemsIndex > -1) {
				draft.homePageItems[homeItemsIndex] = { ...draft.homePageItems[homeItemsIndex], ...payload };
			}
		},
		[types.UPLOAD_START]: (draft: UnsplashRecord) => {
			draft.uploadInProgress = true;
		},
		[types.UPLOAD_END]: (draft: UnsplashRecord) => {
			draft.uploadInProgress = false;
		},
		[types.CLEAR_FORMAT]: (draft: UnsplashRecord) => {
			draft.selectedFormat = undefined;
		},
	}),
};
